// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { UseSignal } from '@jupyterlab/ui-components';
import React from 'react';
import { Search } from '@jupyter/react-components';
const FilterBox = (props) => {
    const onFilterChange = (e) => {
        const filter = e.target.value;
        props.model.filter = filter;
    };
    return (React.createElement(Search, { onChange: onFilterChange, placeholder: props.trans.__('Filter the kernel sources'), value: props.model.filter }));
};
/**
 * A widget which hosts a input textbox to filter on file names.
 */
export const KernelSourcesFilter = (props) => {
    return (React.createElement(UseSignal, { signal: props.model.filterChanged, initialArgs: props.model.filter }, model => React.createElement(FilterBox, { model: props.model, trans: props.trans })));
};
//# sourceMappingURL=filter.js.map